import type {
  TeamContentFragment,
  WorkspaceContentFragment,
} from "gql-types/documents/web-client";
import { TeamMemberAuthorization } from "gql-types/schemas";

export const getIsPro = (
  workspace: WorkspaceContentFragment | TeamContentFragment,
): boolean => {
  if (!workspace.subscription) {
    return false;
  }

  return (
    workspace.subscription.status === "ACTIVE" ||
    workspace.subscription.status === "TRIALING"
  );
};

export const getIsTeamAdmin = (
  currentUserId: string,
  workspace: WorkspaceContentFragment,
) => {
  return (
    workspace?.userAuthorizations?.find((user) => user.userId === currentUserId)
      ?.authorization === TeamMemberAuthorization.Admin
  );
};
